import qs from 'qs'
import request from '@/utils/request'

//登录方法
export const signIn = (data) => {
    return request.post('/index_user/loginokC.html',data)
}

//获取导航
export const getNavigation = (data) => {
  return request.post('/index_user/getleftList.html',data)
}

//新增设备
export const newList = (data) => {
  return request.post('/shebei_indexC/add.html',data)
}

//获取项目管理列表
export const getList = (data) => {
  return request.post('/contract_indexC/index.html',data)
}
//添加项目合同
export const newListHt = (data) => {
  return request.post('/contract_indexC/add.html',data)
}
//查看项目合同详情
export const openXmXq = (data) => {
  return request.post('/contract_indexC/detail.html',data)
}
//修改项目合同
export const editRk = (data) => {
  return request.post('/contract_indexC/updata.html',data)
}
//合同关闭
export const htGuanBi = (data) => {
  return request.post('/contract_indexC/guanbiC.html',data)
}
//合同获取字段详情
export const zd_Xq = (data) => {
  return request.post('/contract_indexC/kaipiao.html',data)
}
//合同字段提交 
export const zd_tj = (data) => {
  return request.post('/contract_indexC/set_kaipiao.html',data)
}
//合同预计结算金额
export const HT_yjJsMoney = (data) => {
  return request.post('/contract_indexC/jiesuanList.html',data)
}
//合同预计结算金额添加
export const HT_yjJsMoneyAdd = (data) => {
  return request.post('/contract_indexC/add_jiesuan.html',data)
}
//合同预计结算金额删除
export const HT_yjJsMoneyDel = (data) => {
  return request.post('/contract_indexC/del_jiesuan.html',data)
}
//合同预计结算金额修改
export const HT_yjJsMoneyEdit = (data) => {
  return request.post('/contract_indexC/updata_jiesuan.html',data)
}
//合同已付金额 
export const HT_YfMoney = (data) => {
  return request.post('/contract_indexC/payList.html',data)
}
//合同删除 
export const del_ht = (data) => {
  return request.post('/contract_indexC/del.html',data)
}
//添加付款 
export const HT_FKMoneyAdd = (data) => {
  return request.post('/contract_indexC/add_pay.html',data)
}
//修改付款
export const HT_FKMoneyEdit = (data) => {
  return request.post('/contract_indexC/updata_pay.html',data)
}
//获取设备详情
export const openXq = (data) => {
  return request.post('/shebei_indexC/detail.html',data)
}
//获取设备修改
export const EditList = (data) => {
  return request.post('/shebei_indexC/updata.html',data)
}
//设备删除
export const sbDel = (data) => {
  return request.post('/shebei_indexC/del.html',data)
}

//租赁设备信息
export const sbxinxi = (data) => {
  return request.post('/contract_indexC/allShebei.html',data)
}
//租赁设备信息提交
export const sbxinxitj = (data) => {
  return request.post('/contract_indexC/bindShebei.html',data)
}
//租赁数量列表 
export const zlnum = (data) => {
  return request.post('/contract_shebeiC/index.html',data)
}
//租赁数量列表关闭列表
export const gbnum = (data) => {
  return request.post('/contract_indexC/guanbiList.html',data)
}
//检测报告列表
export const baogao_list = (data) => {
  return request.post('/contract_shebeiC/reportList.html ',data)
}
//检测报告列表详情
export const baogao_listXq = (data) => {
  return request.post('/shebei_indexC/edit_report.html',data)
}
//检测报告列表详情修改
export const baogao_listEdit = (data) => {
  return request.post('/shebei_indexC/updata_report.html',data)
}
//检测报告列表详情删除
export const baogao_listDel = (data) => {
  return request.post('/shebei_indexC/delReport.html',data)
}
//关联设备 信息 
export const GetHTXq = (data) => {
  return request.post('/contract_shebeiC/detail.html',data)
}
//解除租赁 信息 
export const zulin_over = (data) => {
  return request.post('/contract_shebeiC/execJiechu.html',data)
}

//添加报告 信息 
export const add_BG = (data) => {
  return request.post('/shebei_indexC/add_report.html',data)
}

//开票 信息 
export const kaipiao_list = (data) => {
  return request.post('/contract_indexC/kaipiaoList.html',data)
}
//开票 信息新增 
export const kaipiao_Add = (data) => {
  return request.post('/contract_indexC/add_kaipiao.html',data)
}
//开票 信息修改
export const kaipiao_edit = (data) => {
  return request.post('/contract_indexC/updata_kaipiao.html',data)
}
//停滞 复用 
export const tingzhi_fu = (data) => {
  return request.post('/contract_shebeiC/execTingzhi.html',data)
}
//停滞 复用  删除
export const tingzhi_del = (data) => {
  return request.post('/contract_shebeiC/del.html',data)
}
//停滞 复用  修改
export const tingzhi_edit = (data) => {
  return request.post('/contract_shebeiC/updataTime.html',data)
}

//查看时间
export const look_fy_time = (data) => {
  return request.post('/contract_shebeiC/detailTime.html',data)
}

//用户列表
export const userInfo = (data) => {
  return request.post('/index_user/indexC.html',data)
}

//添加用户
export const userAdd = (data) => {
  return request.post('/index_user/addC.html',data)
}

//查看用户
export const userXinXi = (data) => {
  return request.post('/index_user/detail.html',data)
}

//修改用户
export const userEdit = (data) => {
  return request.post('/index_user/updataC.html',data)
}

//删除用户
export const userDel = (data) => {
  return request.post('/index_user/delC.html',data)
}

//收益列表
export const SyIndex = (data) => {
  return request.post('/shouyi_index/index.html',data)
}

//查询定价列表
export const QueryPricing = (data) => {
  return request.post('/shebei_indexC/index.html',data)
}

//收益列表2
export const CashFlow = (data) => {
  return request.post('/shouyi_index/sbShouyi.html',data)
}

//添加仓库
export const newHousing = (data) => {
  return request.post('/warehouse_index/add.html',data)
}

//修改仓库内容
export const editHousing = (data) =>{
  return request.post('/warehouse_index/updata.html',data)
}

//删除仓库
export const delHousing = (data) =>{
  return request.post('/warehouse_index/del.html',data)
}

//获取仓库内容
export const GetHousingXq = (data) => {
  return request.post('/warehouse_index/detail.html',data)
}

//获取仓库列表
export const GetHousing = (data) => {
  return request.post('/warehouse_index/index.html',data)
}
//获取仓库小列表
export const GetHousingList = (data) => {
  return request.post('/warehouse_index/getAllWarehouse.html',data)
}





// WEBPACK FOOTER //
// ./src/utils/api.js